(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video_banner"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 判断视频没有自动播放时，才执行自定义播放按钮逻辑
  const videos = document.querySelectorAll('video');

  var shouldHandlePlayButton = true;

  videos.forEach(video => {
    if (video.hasAttribute('autoplay')) {
      shouldHandlePlayButton = false;
    }
  });

  if (!shouldHandlePlayButton) {
    // 如果有自动播放，直接返回，不执行后续逻辑
    return;
  }

  // 重置视频和按钮状态的函数
  function resetVideoStates() {
    // 获取所有视频元素
    const videos = document.querySelectorAll('video');
    const playButtons = document.querySelectorAll('button[data-video-play]');
    
    videos.forEach(video => {
      if (video) {
        video.pause(); // 暂停视频
        video.currentTime = 0; // 重置播放进度
        video.controls = false; // 隐藏控件
      }
    });
    
    playButtons.forEach(button => {
      if (button) {
        button.style.display = 'flex'; // 显示播放按钮
        button.style.opacity = '1'; // 确保按钮可见
      }
    });
  }

  // 监听窗口大小变化
  let resizeTimer;
  window.addEventListener('resize', function() {
    // 使用防抖，避免频繁触发
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      resetVideoStates();
    }, 250); // 250ms 延迟
  });

  // 使用事件委托处理所有播放按钮的点击
  document.addEventListener('click', function(e) {
    // 检查点击的是否是播放按钮
    if (e.target.closest('button[data-video-play]')) {
      const playButton = e.target.closest('button[data-video-play]');
      // 查找同一个容器内的 video 元素
      const videoContainer = playButton.closest('div[class*="tw:relative"]');
      const video = videoContainer.querySelector('video');
      
      if (video && playButton) {
        // 播放视频
        video.controls = true; // 显示视频控件
        video.play(); // 播放视频
        playButton.style.opacity = '0'; // 淡出播放按钮
        setTimeout(() => {
          playButton.style.display = 'none'; // 完全隐藏播放按钮
        }, 300);
        
        // 视频结束时的处理
        video.addEventListener('ended', function() {
          video.controls = false; // 隐藏视频控件
          playButton.style.display = 'flex'; // 显示播放按钮
          setTimeout(() => {
            playButton.style.opacity = '1'; // 淡入播放按钮
          }, 10);
        });

        // 视频暂停时的处理
        video.addEventListener('pause', function() {
          if (!video.ended) { // 如果不是因为结束而暂停
            video.controls = true; // 保持控件可见
          }
        });

        // 视频播放时的处理
        video.addEventListener('play', function() {
          playButton.style.display = 'none'; // 确保播放按钮隐藏
        });
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
